if (!customElements.get('product-gallery-modal')) {
  customElements.define('product-gallery-modal', class ProductGalleryModal extends ModalDialog {
      constructor() {
          super();

          this.slider = this.querySelector('slider-component');
          this.tip = this.querySelector('.modal-tip');
      }

      show(opener) {
        super.show(opener);
        this.buildSlides();
        this.filterMediaGroup();
        setTimeout(()=>this.showActiveMedia(), 50);

        // 显示操作提示
        if(this.timer) clearTimeout(this.timer);
        this.tip.classList.add('active');
        this.timer = setTimeout(()=>{
          this.tip.classList.remove('active');
        }, 5000);
      }

      // Slides einmalig aus den Mediendaten der Galerie aufbauen (steht nicht mehr im HTML)
      buildSlides() {
        if(this.built) return;
        const sectionId = this.id.replace('ProductModal-', '');
        const gallery = document.getElementById(`Media-Gallery-${sectionId}`);
        const list = this.querySelector('.modal-media-wrapper');
        if(!gallery || !gallery.lxryMedia || !list) return;
        this.built = true;

        const esc = (v) => String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
        const lazyAnim = gallery.getAttribute('data-lazy-anim');
        const widths = [165, 360, 450, 660, 900, 1320, 1800, 2136, 2400, 3600];
        const playIcon = '<svg class="icon icon-play" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><use href="#lxry-ic-play"></use></svg>';
        const playLabel = this.dataset.labelPlay || '';
        const img = (m) => {
          let srcset = '';
          widths.forEach((w) => { if(m.ow >= w) srcset += `${m.base}&width=${w} ${w}w,\n`; });
          srcset += `${m.base} ${m.ow || 1500}w`;
          const cls = lazyAnim ? `image-lazy-loading loading-animation--${lazyAnim}` : '';
          return `<img${cls ? ` class="${cls}"` : ''} src="${esc(m.base)}&width=10" srcset="${esc(srcset)}" sizes="100vw" alt="${esc(m.alt)}" width="${m.ow}" height="${m.oh}" loading="lazy"${lazyAnim ? ' onload="this.classList.add(\'image-lazy-loaded\')"' : ''}>`;
        };

        let html = '';
        gallery.lxryMedia.forEach((m, i) => {
          let inner;
          if(m.kind === 'image') {
            inner = `<image-magnify data-scale="1.5">${img(m)}</image-magnify>`;
          } else if(m.kind === 'video') {
            inner = `<deferred-media class="video-model-media deferred-media no-js-hidden"><div class="media-poster media">${img(m)}<button class="media-play-button button button--icon button--large button--ambient"${playLabel ? ` aria-label="${esc(playLabel)}"` : ''}>${playIcon}</button></div><template>${m.tpl}</template></deferred-media>`;
          } else {
            inner = `<div class="media-poster media">${img(m)}</div>`;
          }
          html += `<li id="Slide-ProductModal-${i}" class="slider-slide grid-item" data-media-id="${m.id}"${m.group ? ` data-media-group="${esc(m.group)}"` : ''}><div class="modal-media">${inner}</div></li>`;
        });
        list.innerHTML = html;
        if(this.slider && this.slider.initSliderStatus) this.slider.reInstall();
      }

      // Nur Medien der aktuell gewählten Gruppe (Alt-Text ###Gruppe) zeigen; Medien ohne Gruppe bleiben immer sichtbar
      filterMediaGroup() {
        const grouped = this.querySelectorAll('.slider-slide[data-media-group]');
        if(!grouped.length) return;

        const sectionId = this.id.replace('ProductModal-', '');
        const gallery = document.getElementById(`Media-Gallery-${sectionId}`);
        if(!gallery || !gallery.hasAttribute('data-hide-variants')) return;

        const current = gallery.querySelector('.product-media-item.is-current-variant-media-group');
        const fallbackGroup = current ? current.dataset.mediaGroup : null;
        // Nur schreiben/neu installieren, wenn sich die sichtbare Menge seit dem letzten Öffnen ändert
        let changed = false;
        grouped.forEach((slide) => {
          const visible = typeof gallery.groupVisible === 'function'
            ? gallery.groupVisible(slide.dataset.mediaGroup, fallbackGroup)
            : slide.dataset.mediaGroup === fallbackGroup;
          if (slide.classList.contains('is-other-group') === visible) {
            slide.classList.toggle('is-other-group', !visible);
            changed = true;
          }
        });
        if(changed && this.slider && this.slider.initSliderStatus) this.slider.reInstall();
      }

      showActiveMedia(attempt = 0) {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        if(!mediaId) return;

        // Slider installiert sich beim ersten Oeffnen erst, wenn das Modal sichtbar ist
        if(this.slider && !this.slider.initSliderStatus && attempt < 20) {
          setTimeout(() => this.showActiveMedia(attempt + 1), 50);
          return;
        }

        if(this.slider && this.slider.initSliderStatus) {
            const currentSlideElement = this.slider.querySelector(`.slider-slide[data-media-id='${mediaId}']`);
            if(!currentSlideElement) return;

            this.slider.slideByElement(currentSlideElement);

            const deferredMedia = currentSlideElement.querySelector('.deferred-media');
            if(deferredMedia) {
                const deferredMedia = currentSlideElement.querySelector('.deferred-media');
                deferredMedia.loadContent();
            }
        }
      }
    }
  )
}
